import Swiper from "swiper"
import { find } from "utils/dom"

export default function () {
	const Home = find("[js-page='home']")
	if (!Home) return

	document.addEventListener('DOMContentLoaded', () => {
		// Seleciona todos os links dentro da classe .gt_options
		document.querySelectorAll('.gt_options a').forEach(link => {
			const langCode = link.getAttribute('data-gt-lang').toUpperCase(); // Obtém a sigla do idioma e converte para caixa alta
			// Remove o texto atual e substitui apenas pela sigla em caixa alta
			link.innerHTML = `<img data-gt-lazy-src="${link.querySelector('img').getAttribute('data-gt-lazy-src')}" alt="${langCode}" src="${link.querySelector('img').getAttribute('data-gt-lazy-src')}"> ${langCode}`;
		});

		// const arrows = document.querySelectorAll('.gt_float_switcher-arrow')
		// arrows.forEach(i => {
		// 	i.style.rotate = '180deg'
		// })
		// console.log(arrows);

	});
}